export default "__VITE_ASSET__C2mIH_vS__"